import axios from 'axios';
import { AuroraEnv, getEnv } from 'Utils/env';

const {
  KUESKIPAY_FUNNEL_API_LOCAL,
  KUESKIPAY_FUNNEL_API_STAGING,
  KUESKIPAY_FUNNEL_API_PRODUCTION,
} = process.env;

const fetchHTTP = (url, params) => (
  new Promise((resolve, reject) => {
    const stage = getEnv();
    const domains = {
      [AuroraEnv.PRODUCTION]: KUESKIPAY_FUNNEL_API_PRODUCTION,
      [AuroraEnv.STAGING]: KUESKIPAY_FUNNEL_API_STAGING,
    };

    const domain = domains[stage] || KUESKIPAY_FUNNEL_API_LOCAL;

    const authorizationHeader = `Bearer ${localStorage.kueski_session}`;
    const headers = params.headers
      ? {
        Authorization: authorizationHeader, ...params.headers,
      }
      : { Authorization: authorizationHeader };

    axios(`${url}`, { ...params, baseURL: domain, headers })
      .then((response) => {
        /**
         * Authorization header is added in axios interceptor
         * then join it in auth param.
         * Required in Kueski Pusher only.
         */
        const accessToken = response.headers?.Authorization;

        if (response.data.status === 'fail') {
          reject(response.data);
        } else {
          const { data } = response;
          if (typeof data === 'string') {
            resolve(data);
          } else {
            if (accessToken) {
              data.auth = { bearer: accessToken, domain };
            }
            resolve(data);
          }
        }
      })
      .catch(reject);
  })
);

export default fetchHTTP;
